export default "__VITE_ASSET__DogruqFy__"